<div class="lg:pt-3" (window:resize)="onResize()">
  @if (!refreshView) {
    <p-tabView class="frontend frontend-tab-no-padding-x" #tabView>
      @if (match.matchReport) {
        <p-tabPanel [selected]="selectedTab === TAB_REPORT">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-file"></i>
              <span class="font-bold white-space-nowrap m-0">
                {{ 'MATCH_REPORT' | translate }}
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <app-event-match-report [databaseId]="databaseId" [match]="match" [positionTop]="positionTop"
                                    [firstTabInitialization]="firstTabInitialization"
                                    (changeTab)="changeTab($event)"/>
          </ng-template>
        </p-tabPanel>
      }

      <p-tabPanel [selected]="selectedTab === TAB_INFO">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <i [class]="(isMobile ? 'center-icon' : '') + ' pi pi-info-circle'"></i>
            <span class="font-bold white-space-nowrap m-0">
              {{ isMobile ? '' : ('MATCH_DETAILS' | translate) }}
            </span>
          </div>
        </ng-template>
        <div class="frontend-tab-padding">
          <app-event-match-details-info [match]="match"/>
        </div>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === TAB_PERFORMANCES"
                  [disabled]="!match?.hasPerformances">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <i [class]="(isMobile ? 'center-icon' : '') + ' pi pi-flag'"></i>
            <span class="font-bold white-space-nowrap m-0">
                {{ isMobile ? '' : ('BEST_PERFORMANCES' | translate) }}
              </span>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <app-spiel-performances [configurationData]="configurationData"/>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === TAB_STATISTICS"
                  [disabled]="!match?.isDartsscorer || hideStatistics"
                  [pTooltip]="'NO_STATISTICS' | translate" showDelay="400">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <i [class]="(isMobile ? 'center-icon' : '') + ' pi pi-chart-bar'"></i>
            <span class="font-bold white-space-nowrap m-0">
              {{ isMobile ? '' : ('STATISTICS' | translate) }}
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="frontend-tab-padding-x">
            <app-statistic-match-details/>
          </div>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [leftIcon]="(isMobile ? 'center-icon' : '') + ' pi pi-circle-off'"
                  [selected]="selectedTab === TAB_DARTS_SCORER"
                  [disabled]="!match?.isDartsscorer || hideStatistics">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <i [class]="(isMobile ? 'center-icon' : '') + ' pi pi-circle-off'"></i>
            <span class="font-bold white-space-nowrap m-0">
              {{ isMobile ? '' : ('SCOREBOARD' | translate) }}
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="frontend-tab-padding-x">
            <app-spiel-spielverlauf/>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  }
</div>
